// extracted by mini-css-extract-plugin
export default {"submit-button":"pTjEp","default-button":"Q_p9b","card":"f1Nmh"};